/*FAQ form*/
$(function () {

    var faqModal = $('#modalFaq');

    // // Opens success message
    // $('#ModalFaqSubmit').on('click', function() {
    //     formValidate();
    // });


    $('#accordionFAQ a').each(function() {
        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(this.href)) {
            $(this).click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    });

    $('button.accordion-toggle').on('click', function() {
        var target = $(this).data('target'),
            heading = $(this);
        $(target).on('shown.bs.collapse', function() {
            $([document.documentElement, document.body]).animate({
                scrollTop: heading.offset().top
            }, 200);
        });
    });
    

    // Rest for success message
    $('.modal-close').on('click', function() {
        $(this)
            .closest('.modal')
            .find('.modal-success')
            .removeClass('is-active');
    });

    $('#faqForm').validate({
        rules: {
            faqName: "required",
            faqEmail: {
                required: true,
                email: true
            },
            faqPhone : {
                alphanumeric: true
            },
            faqTopic : "required",
            faqQuestion : {
                required : true,
                maxlength: 300
            }
        },
        submitHandler: function(form) {
            faqSumbit();
        }
    });

    jQuery.validator.addMethod("alphanumeric", function(value, element) {
        return this.optional(element) || /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/i.test(value);
    }, "Numbers and dashes only");



    function faqSumbit() {
        var name = $('#faqName').val(),
            email = $('#faqEmail').val(),
            phone = $('#faqPhone').val(),
            org = $('#faqOrganization').val(),
            topic = $('#faqTopic').val(),
            question = $('#faqQuestion').val();


        $.post('/wp-admin/admin-ajax.php', {
            action : "faq_submit",
            name : name,
            email : email,
            phone : phone,
            org : org,
            topic : topic,
            question : question
        }).done(function (r) {
    
            if(r.success) {
                faqModal.find('.modal-success').addClass('is-active');
            } else {
                // console.log('error has occurred');
                var errorCopy = 'An error occurrect with your submission. Please try again. If the issue persists please contact <a href="mailto:info@nhc.org">info@nhc.org</a>',
                    errorMessage = '<h2 class="heading-2 mb-5">Submission Not Recieved</h2><p>'+errorCopy+'</p>';
                faqModal.find('.modal-success .success-body').html(errorMessage);
                faqModal.find('.modal-success').addClass('is-active');
            }
        });	
        
    }
});